export const SIGN_UP = "SIGN_UP" as const;
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS" as const;
export const SIGN_UP_FAILURE = "SIGN_UP_FAILURE" as const;
export const REMOVE_SIGN_UP_FAILURE = "REMOVE_SIGN_UP_FAILURE" as const;

export const signUpAction = (payload: {
  entityId: string;
  email: string;
  password: string;
  entityName: string;
  firstName: string;
  lastName: string;
  roles: string[];
  title?: string;
  phoneNumber?: string;
  professionalPosition?: string;
  location?: any;
  language?: string;
  isExpert?: boolean;
  expertiseDomain?: string;
  specialties?: string[];
  description?: string;
  languages?: string[];
  barAssociation?: string;
  educations?: any[];
  experiences?: any[];
  jurisdictions?: any[];
}) => ({
  type: SIGN_UP,
  ...payload,
});
export type SignUpAction = ReturnType<typeof signUpAction>;

export const signUpActionSuccess = () => ({
  type: SIGN_UP_SUCCESS,
});
export type SignUpActionSuccess = ReturnType<typeof signUpActionSuccess>;

export const signUpActionFailure = () => ({
  type: SIGN_UP_FAILURE,
});
export type SignUpActionFailure = ReturnType<typeof signUpActionFailure>;

export const removeSignUpActionFailure = () => ({
  type: REMOVE_SIGN_UP_FAILURE,
});
export type RemoveSignUpActionFailure = ReturnType<
  typeof removeSignUpActionFailure
>;
